import type { FancyboxInstance, FancyboxOptions } from '@fancyapps/ui';

const SELECTOR_FANCYBOX = '[data-fancybox]';

let inlineDialogId = 0;

export const DEFAULT_FANCYBOX_OPTIONS: Partial<FancyboxOptions> = {
  fadeEffect: true,
  hideScrollbar: true,
  closeButton: false,
};

export function getFancyboxOptions(): Partial<FancyboxOptions> {
  return { ...DEFAULT_FANCYBOX_OPTIONS };
}

export function initFancybox(): void {
  if (!document.querySelector(SELECTOR_FANCYBOX)) {
    return;
  }

  void loadAndBind();
}

function getInlineDialogSelector(element: HTMLElement): string {
  if (!element.id) {
    inlineDialogId += 1;
    element.id = `fancybox-inline-${inlineDialogId}`;
  }

  return `#${CSS.escape(element.id)}`;
}

export async function closeFancybox(): Promise<void> {
  try {
    const { Fancybox } = await import('@fancyapps/ui');

    Fancybox.close();
  }
  catch (error) {
    console.warn('Failed to close Fancybox', error);
  }
}

export async function openInlineFancybox(
  element: HTMLElement,
  options?: Partial<FancyboxOptions>,
): Promise<FancyboxInstance | undefined> {
  try {
    const { Fancybox } = await import('@fancyapps/ui');

    return Fancybox.show(
      [{ src: getInlineDialogSelector(element), type: 'inline' }],
      {
        ...getFancyboxOptions(),
        ...options,
      },
    );
  }
  catch (error) {
    console.warn('Failed to open Fancybox', error);

    return undefined;
  }
}

async function loadAndBind(): Promise<void> {
  try {
    const { Fancybox } = await import('@fancyapps/ui');

    Fancybox.bind(SELECTOR_FANCYBOX, getFancyboxOptions());
  }
  catch (error) {
    console.warn('Failed to load Fancybox', error);
  }
}
